import { createResourceStore } from "@/lib/resource";
import type { Shop } from "./Shop";
import type { Business } from "./Business";

import type { Asset } from "./Asset";

export interface Category {
  id: string;
  name: string;
  description: string | null;
  //
  business_id: string;
  shop_id: string;
  created_at: string;
  updated_at: string;
  //
  shop: Shop;
  business: Business;
  image: Asset;
}

export const useCategory = createResourceStore<Category>("categories");
